import type { AddressDto } from '@dhl/mdp-api'
import type { Address } from '~/common/components/addresses'

export const convertToAddressDto = ({
  houseNumber,
  houseNumberSuffix,
  postalCode,
  ...address
}: Address): AddressDto => ({
  ...address,
  number: houseNumber,
  addition: houseNumberSuffix,
  zipCode: postalCode,
})
